var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeclineIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 9,
    fill: "#DC2020"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.46984 9.00009L11.8998 6.57009C12.0131 6.43783 12.0055 6.24069 11.8824 6.11757C11.7592 5.99444 11.5621 5.98683 11.4298 6.10009L8.99984 8.53009L6.56984 6.09675C6.43759 5.9835 6.24044 5.99111 6.11732 6.11423C5.99419 6.23736 5.98658 6.4345 6.09984 6.56675L8.52984 9.00009L6.09651 11.4301C6.00138 11.5116 5.95994 11.6395 5.98924 11.7612C6.01853 11.883 6.1136 11.9781 6.23537 12.0074C6.35713 12.0366 6.48504 11.9952 6.56651 11.9001L8.99984 9.47009L11.4298 11.9001C11.5621 12.0133 11.7592 12.0057 11.8824 11.8826C12.0055 11.7595 12.0131 11.5623 11.8998 11.4301L9.46984 9.00009Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeclineIcon);
export default __webpack_public_path__ + "static/media/decline-icon.8f6e40bc5d549db9a502eed5969a3605.svg";
export { ForwardRef as ReactComponent };